module.exports = __webpack_public_path__ + "static/media/related-entries.c8818eb5.svg";